'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosRecording = function IoIosRecording(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.9 11.3c4.8 0 8.6 3.9 8.6 8.7s-3.8 8.8-8.6 8.8h-20.3c-4.8 0-8.6-4-8.6-8.8s3.8-8.7 8.6-8.7 8.6 3.9 8.6 8.7c0 3.1-1.7 5.9-4.2 7.4h11.4c-2.5-1.5-4.1-4.3-4.1-7.4 0-4.8 3.8-8.7 8.6-8.7z m-20.1 13.7c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.2 5 5 5z m20 0c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.2 5 5 5z m0-8.7c2 0 3.7 1.7 3.7 3.7s-1.7 3.8-3.7 3.8-3.8-1.8-3.8-3.8 1.7-3.7 3.8-3.7z m-20 0c2 0 3.7 1.7 3.7 3.7s-1.7 3.8-3.7 3.8-3.8-1.8-3.8-3.8 1.7-3.7 3.8-3.7z' })
        )
    );
};

exports.default = IoIosRecording;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-recording.js
// module id = 2745
// module chunks = 168707334958949